import React, { useEffect, useState, useRef } from "react";
import styles from "./detailsBox.module.scss";
import timeIcon from "../../../assets/icons/programs/major/timeStamp.svg";
import calendarIcon from "../../../assets/icons/programs/major/calendar.svg";
import studentIcon from "../../../assets/icons/programs/major/student.svg";
import policeManIcon from "../../../assets/Imagess/policeMan.svg";

import languageIcon from "../../../assets/icons/programs/major/languages.svg";
import moreInfo from "../../../assets/icons/programs/major/moreInfo.svg";
import Separator from "../../Atoms/separator/Separator";
import editSvg from "../../../assets/icons/formActions/edit.svg";
import deleteSvg from "../../../assets/icons/formActions/delete.svg";
import ApplicantsTab from "../../Atoms/Tabs/InfoTab";
import facilityIcon from "../../../assets/Imagess/facility.svg";
import researchIcon from "../../../assets/Imagess/research.svg";

import emailIcon from "../../../assets/Imagess/GreenEmail.svg";
import phoneIcon from "../../../assets/Imagess/GreenPhone.svg";
import AttachmentsIcon from "../../../assets/Imagess/GeneralIcon.svg";
import FormIcon from "../../../assets/Imagess/LikertIcon.svg";
import Buttons from "../../Atoms/Buttons/Buttons";

import InfoButton from "../../Atoms/InfoButton/InfoButton";
import InfoCard from "../../Atoms/Cards/InfoCard";
import QuestionCard from "../../Atoms/Cards/QuestionCard";
import { useNavigate } from "react-router-dom";
import BackIcon from "../../../assets/Imagess/BackIcon.svg";
import ExportIcon from "../../../assets/Imagess/exportIcon.svg";
import PrintIcon from "../../../assets/Imagess/printIcon.svg";
import Attachments from "./Attachments";

import DownloadAllIcon from "../../../assets/Imagess/DownloadAllIcon.svg";
import { useDownloadAllAttachments } from "../../../Hooks/Applications";
import MoreButton from "../../Molecules/Custom/MoreButton";
import ReactToPrint from "react-to-print";
import printicon from "../../../assets/Imagess/printIcon.svg";

function DetailsBox({
  data,
  details,
  setDetails,
  applicantId = "",
  moveRight = false,
  setMoveRight,
}) {
  const navigate = useNavigate();
  const menuItems = [
    {
      label: "Export",
      icon: ExportIcon,
      // onClick: () => navigate("/home/programs/edit/11"),
    },
    {
      label: "Print",
      icon: PrintIcon,
      onClick: () => {},
    },
  ];

  const [info, setInfo] = useState(null);
  const [selected, setSelected] = useState("likert");
  const [academic_Records, setAcademic_Records] = useState("No Attachment");
  const [answers, setAnswers] = useState([]);
  const [percentages, setPercentages] = useState([]);

  const [printMode, setPrintMode] = useState(false);

  let componentRef = useRef();

  const tabs = [
    {
      index: 0,
      name: "likert",
      text: "Likert Questions",
      icon: FormIcon,
    },
    {
      index: 1,
      name: "generalQuestions",
      text: "General Questions",
      icon: AttachmentsIcon,
    },
  ];

  useEffect(() => {
    if (data) {
      let arr = [];
      let arr1 = [];
      for (let i = 0; i < data.quizResultAreaPercentange.length; i++) {
        const element = data.quizResultAreaPercentange[i];
        arr.push(element.areaOfInterest);
      }
      setAnswers(arr);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      let Questions = [
        {
          Question:
            "How relevant do you believe this program is to the specific career you wish to pursue?",
          Answers: answers,
          Percentages: [],
        },
        {
          Question:
            "What is your level of interest in gaining specialized skills and knowledge from the selected degree?",
          Answers: answers,
          Percentages: [],
        },
        {
          Question:
            "To what extent do you believe a law degree will contribute to your long-term career goals?",
          Answers: answers,
          Percentages: [],
        },
        {
          Question:
            "How much value do you place on having opportunities for networking and mentorship within your law program?",
          Answers: answers,
          Percentages: [],
        },
        {
          Question:
            "How relevant is your current degree to the selection you made?",
          Answers: answers,
          Percentages: [],
        },
      ];

      for (let i = 0; i < Questions.length; i++) {
        const element = Questions[i];
        element.Percentages = [];
        for (let j = 0; j < data.quizResultAreaPercentange.length; j++) {
          const element1 = data.quizResultAreaPercentange[j];
          let keys = Object.keys(element1);
          element.Percentages.push(element1[keys[i]]);
        }
      }

      setInfo({
        fullName: data.quizResults[0] && data.quizResults[0].userName,
        email: data.quizResults[0] && data.quizResults[0].userEmail,
        program: [
          {
            title: "Degree",
            text:
              data.quizResults[0] &&
              data.quizResults[0].degreeSuggested.degreeType === 1
                ? "Master’s"
                : "PHD",
          },
          {
            title: "Suggested Program",
            text:
              data.quizResults[0] &&
              data.quizResults[0].degreeSuggested.degreeNameEn,
          },
        ],
        Questions: Questions,
        GeneralQuestions: data && data.quizResultAnswers,
      });
    }
  }, [answers]);

  //-------------------------------------------------------------

  const downloadAttachment = useDownloadAllAttachments(applicantId);
  const handleDownloadAll = async (contentType) => {
    try {
      var data = await downloadAttachment.mutateAsync();

      if (data.data instanceof Blob) {
        const blob = new Blob([data.data], {
          type: contentType,
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "All Attached Files";
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        console.error("Unexpected data type. Expected string.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <>
      <div
        className={`${styles["parentContainer"]}`}
        id={"PrintDetails"}
        ref={(el) => (componentRef = el)}
      >
   
        <div className={`${styles["major-box"]} `}>
          <div className={` ${styles["box-side"]} `}>
            <img src={policeManIcon} className={` ${styles["leftImg"]} `} />
          </div>
          <div className={`${styles["box-body"]} `}>
            <h3>{info && info.fullName}</h3>
            {info && (
              <span className={styles["spanCont"]}>
                {" "}
                <img src={emailIcon} />
                {info.email}
              </span>
            )}
            {info && (
              <span className={styles["spanCont"]}>
                {" "}
                <img src={phoneIcon} />
                {info.phone}
              </span>
            )}
            &nbsp; &nbsp;
            <hr></hr>
            <div className={`${styles["row"]} ${styles["programs"]} `}>
              {info &&
                info.program.map((i, index) => (
                  <div
                    key={index}
                    className={`${
                      index === 0 ? styles["w-10"] : styles["w-40"]
                    }`}
                  >
                    <h4>{i.title}</h4>
                    <span> {i.text}</span>
                  </div>
                ))}
            </div>
          </div>
        </div>

        <div
          className={`${styles["tab-select-container"]} ${styles["row"]}`}
          style={{ marginTop: "25px", marginBottom: "15px" }}
        >
          <div className={`${styles["tab-container"]} ${styles["w-90"]}`}>
            {tabs.map((tab) => (
              <ApplicantsTab
                key={tab.index}
                text={tab.text}
                icon={tab.icon}
                handleOnClick={() => {
                  setSelected(tab.name);
                }}
                active={tab.name === selected ? true : false}
                shadowed={false}
              />
            ))}
          </div>

          <div
            style={{
              position: "absolute",
              right: "40px",
              marginTop: "25px",
            }}
            className={`  ${styles["no-print"]} `}
          >
            <MoreButton icon={moreInfo} top={1} right={30}>
              <div className={styles["in-container"]}>
                {/* <div>
                  <div>
                    {" "}
                    <img src={ExportIcon} alt='profile' /> <span>Export</span>
                  </div>{" "}
                </div> */}
                <div>
                  <ReactToPrint
                    trigger={() => (
                      <div>
                        <img src={PrintIcon} alt='Details' />
                        <span>Print</span>
                      </div>
                    )}
                    onAfterPrint={() => setPrintMode(false)}
                    onBeforeGetContent={() => {
                      setPrintMode(true);
                    }}
                    content={() => componentRef}
                  />
                </div>
              </div>
            </MoreButton>
          </div>
        </div>
        {/* <ComponentToPrint ref={(el) => (componentRef = el)} /> */}
        {selected === "likert" ? (
          <div className={`${styles["row"]} `}>
            <QuestionCard
              title={
                "What are the following areas of law interests you the most?"
              }
              answers={answers}
              width={"w-100"}
              type={1}
            />
            {info &&
              info.Questions.map((item, index) => (
                <QuestionCard
                  key={index}
                  arrayIdx={index}
                  title={item.Question}
                  answers={item.Answers}
                  percentages={item.Percentages}
                  width={"w-49"}
                />
              ))}
          </div>
        ) : (
          <div className={`${styles["row"]} `}>
            {info &&
              info.GeneralQuestions.map((item) => (
                <QuestionCard
                  title={
                    item.question.charAt(0).toUpperCase() +
                    item.question.slice(1)
                  }
                  answers={[item.answer]}
                  width={"w-49"}
                  type={2}
                />
              ))}
          </div>
        )}
      </div>
    </>
  );
}

export default DetailsBox;
